export const MAX_SIZE_FILE = 2 * 1024 * 1024;

export const CONFIG: ConfigInterface = {
  call: {
    noMic: false,
    noCam: false,
    sound: 1,
  },
  notification: {
    silenceNotification: false,
  },
  sound: {
    silenceReactions: false,
  },
  chat: {
    openRoomChatByDefault: false,
  },
};

export interface ConfigInterface {
  call: {
    noMic: boolean;
    noCam: boolean;
    sound: number;
  };
  notification: {
    silenceNotification: boolean;
  };
  sound: {
    silenceReactions: boolean;
  };
  chat: {
    openRoomChatByDefault: boolean;
  };
}
